;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = require("axios");

var _axios2 = _interopRequireDefault(_axios);

var _xlsx = require("xlsx");

var _xlsx2 = _interopRequireDefault(_xlsx);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "SettlemetMonthlyReport",
  props: ["settlement_first_year"],
  data: function data() {
    return {
      records: [],
      selectedMonths: [],
      selectedMonth: {},
      months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      page: 1,
      perPage: 20,
      totalPages: 1,
      years: [],
      selectedYear: null,
      startYear: 2000,
      currentYear: new Date().getFullYear(),
      isLoading: false,
      downLoading: false
    };
  },

  watch: {
    filtersChanges: function filtersChanges(newVal, oldVal) {
      this.fetchReport();
    }
  },
  computed: {
    canDownload: function canDownload() {
      if (this.selectedMonth && this.selectedYear !== null && this.records && this.records.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    allMonths: function allMonths() {
      var _this = this;

      if (this.months.length > 0) {
        return this.months.map(function (month) {
          return {
            label: month,
            value: (_this.months.indexOf(month) + 1).toString().padStart(2, "0")
          };
        });
      }
    },
    filtersChanges: function filtersChanges() {
      return this.selectedMonth.value + " | " + this.selectedYear + " | " + this.page + " | " + this.perPage;
    }
  },
  mounted: function mounted() {
    if (this.settlement_first_year) {
      this.startYear = this.settlement_first_year;
    }

    this.getYearsInRange(this.startYear, this.currentYear);
  },

  methods: {
    formatDates: function formatDates(date_or_datetime) {
      return moment(date_or_datetime).format("LLL");
    },
    getYearsInRange: function getYearsInRange(start, end) {
      while (start <= end) {
        this.years.push(start++);
      }
      return this.years;
    },
    computeNetAmount: function computeNetAmount(amount1, amount2) {
      var res = amount1 - amount2;
      return res;
    },
    formatAmount: function formatAmount(amnt) {
      return Math.round(amnt);
    },
    fetchReport: function fetchReport() {
      var _this2 = this;

      if (this.selectedMonth && this.selectedYear !== null) {
        this.isLoading = true;
        _axios2.default.get("/settlements/filtered", {
          params: {
            month: this.selectedMonth.value,
            year: this.selectedYear,
            page: this.page
          }
        }).then(function (_ref) {
          var data = _ref.data;

          _this2.records = data.entries;
          _this2.totalPages = data.total_pages;
        }).catch(function (error) {
          _this2.records = [];
        }).finally(function () {
          _this2.isLoading = false;
        });
      }
    },
    nextPage: function nextPage(currentPage) {
      if (currentPage && currentPage != this.totalPages) {
        return this.page = currentPage + 1;
      } else {
        return this.page = currentPage;
      }
    },
    prevPage: function prevPage(currentPage) {
      if (currentPage && currentPage !== 1 && currentPage > 1) {
        return this.page = currentPage - 1;
      } else {
        return this.page = currentPage;
      }
    },
    downLoadReport: function downLoadReport() {
      var _this3 = this;

      this.downLoading = true;
      var filename = "Settlement-report-" + this.selectedMonth.value + "-" + this.selectedYear + ".xlsx";
      var filepath = "/uploads/" + filename;
      _axios2.default.get("/settlements/filtered/download", {
        params: {
          month: this.selectedMonth.value,
          year: this.selectedYear,
          filename: filename
        }
      }).then(function (response) {
        setTimeout(function () {
          _this3.downLoading = false;
          window.open(filepath, '_blank').focus();
        }, 20000);
      }).catch(function (error) {}).finally(function () {});
    },
    formatForDownload: function formatForDownload(data) {
      var _this4 = this;

      return data.map(function (row) {
        return {
          "Date Created": _this4.formatDates(row.time),
          "Invoice Number": row.invoice_number,
          "Service": row.service_name,
          "Description": row.item_desc,
          "Currency": row.currency,
          "Gross Amount": row.value,
          "Access Fee": row.commission,
          "Net Amount": _this4.computeNetAmount(row.value, row.commission),
          "Status": row.status
        };
      });
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card",attrs:{"data-toggle":"lists"}},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('v-select',{attrs:{"options":_vm.allMonths},model:{value:(_vm.selectedMonth),callback:function ($$v) {_vm.selectedMonth=$$v},expression:"selectedMonth"}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('v-select',{attrs:{"options":_vm.years},model:{value:(_vm.selectedYear),callback:function ($$v) {_vm.selectedYear=$$v},expression:"selectedYear"}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[(_vm.canDownload)?_c('button',{staticClass:"btn btn-outline-info border-radius-10",attrs:{"type":"button","id":"req_report","disabled":_vm.downLoading},on:{"click":function($event){return _vm.downLoadReport()}}},[_c('svg',{attrs:{"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6.66602 14.6667L9.99935 18M9.99935 18L13.3327 14.6667M9.99935 18V10.5M16.666 14.4524C17.6839 13.6117 18.3327 12.3399 18.3327 10.9167C18.3327 8.38536 16.2807 6.33333 13.7493 6.33333C13.5673 6.33333 13.3969 6.23833 13.3044 6.08145C12.2177 4.23736 10.2114 3 7.91602 3C4.46424 3 1.66602 5.79822 1.66602 9.25C1.66602 10.9718 2.36222 12.5309 3.48847 13.6613","stroke":"currentColor","stroke-width":"1.66667","stroke-linecap":"round","stroke-linejoin":"round"}})]),_vm._v(" "),(!_vm.downLoading)?_c('span',[_vm._v("Download Report")]):_c('span',[_vm._v("Downloading...")])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[(_vm.records.length > 0 && !_vm.isLoading)?_c('table',{staticClass:"table table-sm table-hover table-nowrap card-table"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.records),function(row,index){return _c('tr',{key:index},[_c('td',[_vm._v("\n                "+_vm._s(_vm.formatDates(row.time))+"\n              ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.invoice_number))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.service_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.item_desc))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.currency))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.value))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.commission))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.computeNetAmount(row.value, row.commission)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.status))])])}),0)]):(_vm.isLoading)?_c('div',{staticClass:"text-center text-bold"},[_vm._m(2)]):_c('div',{staticClass:"text-center text-bold"},[_vm._m(3)]),_vm._v(" "),_c('div',{staticClass:"card-footer bg-white d-flex justify-content-between"},[_c('div',{staticClass:"pull-right"}),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('nav',{attrs:{"aria-label":"Page navigation example"}},[_c('ul',{staticClass:"pagination"},[_c('li',{staticClass:"page-item",on:{"click":function($event){return _vm.prevPage(_vm.page)}}},[_c('a',{staticClass:"page-link",attrs:{"href":"javascript:void(0)"}},[_vm._v("Previous")])]),_vm._v(" "),_c('li',{staticClass:"page-item",on:{"click":function($event){return _vm.nextPage(_vm.page)}}},[_c('a',{staticClass:"page-link",attrs:{"href":"javascript:void(0)"}},[_vm._v("Next")])]),_vm._v(" "),_c('li',{staticClass:"page-item d-flex"},[_c('a',{staticClass:"page-link",attrs:{"href":"javascript:void(0)"}},[_vm._v("Page "+_vm._s(_vm.page)+" of "+_vm._s(_vm.totalPages))])])])])])])])])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header mt-md-5"},[_c('div',{staticClass:"header-body"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col"},[_c('h6',{staticClass:"header-pretitle"},[_vm._v("Overview")]),_vm._v(" "),_c('h1',{staticClass:"header-title"},[_vm._v("Settlement Report")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("\n              Generate reports for specific months and year.\n            ")])])])])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Date Created")]),_vm._v(" "),_c('th',[_vm._v("Invoice Number")]),_vm._v(" "),_c('th',[_vm._v("Service")]),_vm._v(" "),_c('th',[_vm._v("Description")]),_vm._v(" "),_c('th',[_vm._v("Currency")]),_vm._v(" "),_c('th',[_vm._v("Gross Amount")]),_vm._v(" "),_c('th',[_vm._v("Access Fee")]),_vm._v(" "),_c('th',[_vm._v("Net Amount")]),_vm._v(" "),_c('th',[_vm._v("Status")])])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-border",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v(" No Records to Display. Select report period to view. ")])])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-81ff9f72", __vue__options__)
  } else {
    hotAPI.reload("data-v-81ff9f72", __vue__options__)
  }
})()}